<template>
  <div class="bl_area capture_area">
    <form
      id="frm_shipping"
      @submit.prevent
    >
      <h2 class="content_title">{{ $t('msg.CSBL200.231') }}</h2>
      <table class="tbl_col">
        <colgroup>
          <col width="14%">
          <col width="36%">
          <col width="14%">
          <col width="36%">
        </colgroup>
        <tbody>
          <tr>
            <th class="text_left">
              {{ $t('msg.NEWB020G010.043') }}
            </th>
            <td>
              <e-trans-address-input
                :id="'actShprCstEnm'"
                ref="actShprCstEnm"
                v-model="regParams.actShprCstEnm"
                :is-required="true"
                :is-char="true"
                :max-length="50"
                :message-required="$t('msg.CSBK100.147')"
                @input="checkValidationInfo('actShprCstEnm')"
              />
            </td>
            <th class="text_left">
              {{ $t('msg.NEWB020G010.044') }}
            </th>
            <td>
              <e-trans-address-input
                :id="'cneCstEnm'"
                ref="cneCstEnm"
                v-model="regParams.cneCstEnm"
                :is-required="true"
                :is-char="true"
                :max-length="50"
                :message-required="$t('msg.CSBK100.147')"
                @input="checkValidationInfo('cneCstEnm')"
              />
            </td>
          </tr>
          <tr>
            <th></th>
            <td class="text_left">
              <ETextarea2 :id="'actShprCstAddr'"
                          ref="actShprCstAddr"
                          :max-line="5"
                          :column-length="50"
                          v-model="regParams.actShprCstAddr"
                          :is-char="true"
              />
              <!-- <div v-if="isShipperLOIPlc && isShipperLOI" class="shp_msg">
                <span v-if="$ekmtcCommon.isEmpty(saveShipperLOI)" class="shp_msg_txt">{{ $t('msg.CSBL200.222') }}</span>
                <div class="d_inline_flex">
                  <a class="button sm mt5" @click="fnCommonBtnAction('TRD_SHIPPER')">{{ $t('msg.CSBL200.272') }}</a>
                  <a v-if="$ekmtcCommon.isNotEmpty(saveShipperLOI)" class="btn_doc mt5" @click.prevent="fnCommonBtnAction('TRD_SHIPPER_FILE')">Shipper LOI 첨부 확인</a>
                </div>
              </div> -->
            </td>
            <th></th>
            <td>
              <ETextarea2 :id="'cneCstAddr'"
                          ref="cneCstAddr"
                          :max-line="5"
                          :column-length="50"
                          :is-char="true"
                          v-model="regParams.cneCstAddr"
              />
            </td>
          </tr>

          <tr>
            <th class="text_left">
              {{ $t('msg.NEWB020G010.047') }}  <!-- Notify1 -->
            </th>
            <td>
              <e-trans-address-input
                :id="'ntifCstEnm1'"
                ref="ntifCstEnm1"
                v-model="regParams.ntifCstEnm1"
                :is-required="true"
                :is-char="true"
                :max-length="50"
                :message-required="$t('msg.CSBK100.147')"
                @input="checkValidationInfo('ntifCstEnm1')"
              />
            </td>
            <th class="text_left">
              {{ $t('msg.NEWB020G010.048') }}  <!-- Notify2 -->
            </th>
            <td>
              <e-trans-address-input :id="'ntifCstEnm2'"
                                     ref="ntifCstEnm2"
                                     v-model="regParams.ntifCstEnm2"
                                     :is-required="false"
                                     :is-char="true"
                                     :max-length="50"
                                     :message-required="$t('msg.CSBK100.147')"
              />
            </td>
          </tr>
          <tr>
            <th></th>
            <td>
              <ETextarea2 :id="'ntifCstAddr1'"
                          ref="ntifCstAddr1"
                          :max-line="5"
                          :column-length="50"
                          :is-char="true"
                          v-model="regParams.ntifCstAddr1"
              />
            </td>
            <th></th>
            <td>
              <ETextarea2 :id="'ntifCstAddr2'"
                          ref="ntifCstAddr2"
                          :max-line="5"
                          :column-length="50"
                          :is-char="true"
                          v-model="regParams.ntifCstAddr2"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</template>

<script>
import { rootComputed } from '@/store/helpers'
import commons from '@/api/services/commons'
import trans from '@/api/rest/trans/trans'
import BookingScheduleInfo from '@/components/trans/BookingScheduleInfo'
import EInputNumber from '@/components/common/EInputNumber'
import EDatePicker from '@/components/common/EDatePicker'
import ETransStringCheckInput from '@/components/trans/ETransStringCheckInput'
import ETransAddressInput from '@/components/trans/ETransAddressInput'
import ETransAddressTextarea from '@/components/trans/ETransAddressTextarea'
import ETransStringCheckCneeInput from '@/components/trans/ETransStringCheckCneeInput'
import ETextareaLineColumn from '@/components/common/ETextareaLineColumn'
//
import ETextarea from '@/components/common/ETextarea'
import ETextarea2 from '@/components/common/ETextarea2'

export default {
  name: 'WorkingHouseBlShppierInfo',
  components: {
    ETextarea,
    ETextarea2,
    //
    BookingScheduleInfo,
    EInputNumber,
    EDatePicker,
    ETransStringCheckInput,
    ETransAddressInput,
    ETransAddressTextarea,
    ETransStringCheckCneeInput,
    ETextareaLineColumn
  },
  props: {
    parentInfo: {
      type: Object,
      default: () => {
          return []
      }
    }
  },
  data () {
    return {
      cstInfoList: [],
      lang: '',
      usrCtrCd: '',
      cstCatCd: '',
      blgPlcCd: '',
      saveFlag: 'BL_EDIT',
      selectBeforeVal: '',
      commonCodes: {},
      plcEnmCodes: {},
      cstEnmCodes: {},
      ctrCdList: [],
      ctrCdIccList: [],
      actCstIdList: [],
      cneCstIdList: [],
      notiCstIdList: [],
      cgoTypCdList: [],
      cntrRfStsList: [],
      issPlcList: [],
      frtPayPlcList: [],
      topMarkList: [],
      topDscrList: [],
      blEdiTypCdList: [],
      blPhbtList: [],
      deckCdList: [],
      pkgCdList: [],
      indiaCityList: [],
      blCopyOpen: 'N',
      blRequestOpen: 'N',
      vgmPopOpen: 'N',
      isCstId: false, // Company ID 입력란 생성 여부
      addrStr: '',
      isPolHsMulti: false,
      isPodHsMulti: false,
      saveCntrCnt: 1,
      customComponent: null,
      popParams: {},
      selectFunc: {},
      commonBLComponent: null,
      commonBLParams: {},
      commonBLCallback: null,
      porPlcNmType: 'select',
      polPortNmType: 'select',
      podPortNmType: 'select',
      dlyPlcNmType: 'select',
      freeTime: '',
      serverYear: '',
      serverMonth: '',
      serverDay: '',
      serverHour: '',
      serverMin: '',
      saveType: '',
      dscrStr: '',
      byStr: '',
      timeFlag: '',
      elDateFlag: '',
      blDetailDis: '',
      descrCaYn: '',
      cgoRest: '',
      closeEl: false, // E/L 정보 수정 불가 여부
      closeCntr: false, // 컨테이너 정보 수정 불가 여부
      rfDisabled: false,
      uploadFile: true,
      isBlAdd: true,
      isShipperLOI: false,
      isShipperLOIPlc: true, // Shipper LOI 첨부 가능지역여부
      excelUploadShow: true,
      saveShipperLOI: '',
      phbtAlertMsg: [],
      originParams: {},
      originCntrLen: 0, // 조회됐을때 컨테이너 Length. (originParams는 1차 가공된 정보라서 별도 변수 생성)
      pkgInfo: '',
      docPicNo: '',
      hsChkParams: {
        maxlengthPolHsCd: '6',
        maxlengthPodHsCd: '6',
        hscdPolErrorMessage: '',
        hscdPodErrorMessage: '',
        polCtrCd: '',
        podCtrCd: '',
        polSuccYn: '',
        podSuccYn: ''
      },
      regParams: {
        bkgNo: '',
        blNo: '',
        fwdrBlNo: '',
        docPicNo: '',
        bizPicNm: '',
        bizPicTelPlcNo: '',
        bizPicTelOfcNo: '',
        bizPicFaxPlcNo: '',
        bizPicFaxOfcNo: '',
        bizPicMbpBsnNo: '',
        bizPicMbpOfcNo: '',
        bizPicEmlAddr: '',
        docPicNm: '',
        docPicEmlAddr: '',
        docPicTelPlcNo: '',
        docPicTelNo: '',
        docPicFaxPlcNo: '',
        docPicFaxNo: '',
        docPicMbpBsnNo: '',
        docPicMbpNo: '',
        shprCstEnm: '',
        shprCstAddr: '',
        actShprCstCtrCd: '',
        actShprStateCd: '',
        cneCstCtrCd: '',
        cneCstStateCd: '',
        cneCstEnm: '',
        cneCstAddr: '',
        cneNatlId: '', // 도착국가 : 이란
        ntifCstCtrCd: '',
        ntifCstStateCd: '',
        ntifCstEnm: '',
        ntifCstAddr: '',
        ntfyNatlId: '', // 도착국가 : 이란
        porPlcNm: '', // Place of Receipt
        polPortNm: '', // Port of Loading
        podPortNm: '', // Port of Discharge
        dlyPlcNm: '', // Place of Delivery
        lstDestPlcNm: '', // Final Destination
        obrdDt: '',
        frtPncCd: 'P',
        polShtmCd: '',
        podShtmCd: '',
        grsCbm: '',
        grsWt: '',
        actShprIdCatCd: '',
        actShprIdNo: '',
        cneIdCatCd: '',
        cneIdNo: '',
        ntifIdCatCd: '',
        ntifIdNo: '',
        acidNo: '',
        cneAcidNo: '',
        pkgCd: '',
        blDclrYn: 'N',
        issCtrCd: '',
        issPlcCd: '',
        frtPayCtrCd: '',
        frtPayPlcCd: '',
        frtAppNo: '',
        cstBidgMgrNo: '',
        hsCd: '',
        podHsCd: '',
        podHsCdNm: '',
        machineRmk: '',
        blTypCd: '',
        orgBlTypCd: '',
        exportLicenseList: [],
        containerList: [],
        markDescList: [],
        reqList: [],
        addBkgNoList: [],
        cnCaFlag: 'Y',
        tsCgoChoYn: '',
        consCgoYn: '',
        etcYn: '',
        cneBinNo: '',
        ntifBinNo: '',
        amsType: '',
        amsSendYn: '',
        imShprTaxId: '',
        imCneTaxId: '',
        imNtifTaxId: '',
        actShprCstAddr: '',
        ntifCstAddr1: '',
        ntifCstAddr2: ''
      },
      updateBLParams: {
        blMaster: [],
        mrkMaster: [],
        cntrMaster: [],
        liceMaster: []
      },
      uploadFileList: [],
      timer: null,
      sayChk: true,
      vueMode: true, //process.env.VUE_APP_MODE !== 'PRD'
      autoSayYn: 'N',
      templateCd: 'A',
      templateNo: '',
      templateNo_2: '',
      templateList: [],
      checkCgoType: 'Y',
      blTypeVisibleContry: [],
      fmcShprEnm: '',
      fmcCneEnm: '',
      fmcEnmList: [],
      orderYn: false,
      regHbParams: {}
   }
  },
  computed: {
    ...rootComputed
  },
  watch: {
  },
  created () {
    this._ = require('lodash')

    this.init()
  },
  mounted () {
    if (this.regParams.caYn === 'Y') {
      $('#frm_shipping input,#frm_shipping textarea').prop('disabled', true)
    }
  },
  methods: {
    async init () {
      this.regParams = this.parentInfo.houseBlList
    },
    sendShippingInfo () {
      return this.regParams
    },
    async inputValidation () {
      const TH = this
      const type = TH.saveType
      const regParams = TH.regParams
      let isOk = true

      if (!this.checkValidationInfoAll()) {
        isOk = false
      }

      if (!this.checkValidationCntrAll()) {
        isOk = false
      }

      // 중국인 경우만 say 필수값 체크
      if (this.checkValidationCntrAll() && (this.regParams.blPrtSntcCont === undefined || this.regParams.blPrtSntcCont === '')) {
        this.checkValidationInfo('blPrtSntcCont')
        this.sayChk = false
        isOk = false
      }
      if (!this.checkValidationMarkDesc()) {
        isOk = false
      }

      return isOk
    },
    async validation () {
      let isOk = true
      const TH = this
      const regParams = TH.regParams

      const cgoTypList = regParams.cgoTypList
      const containerList = regParams.containerList

      await commons.getServerTime().then(res => {
        this.serverYear = res.data.substring(0, 4)
        this.serverMonth = res.data.substring(4, 6)
        this.serverDay = res.data.substring(6, 8)
      })

      if (!await this.inputValidation()) {
        isOk = false
      }

      return isOk
    },
    checkErrorVisible (id) {
      const frm = document.querySelector('#frm_shipping')
      const elem = frm.querySelector('#' + id)

      const parentElem = $(elem).parents('td, div').eq(0)
      const msgBox = parentElem.find('.tooltip_essen_box').eq(0)

      if (msgBox.length > 0 && msgBox.is(':visible') && this.$ekmtcCommon.isNotEmpty(elem.value)) {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }
    },
    hideTooltip (id) {
      $('#' + id).hide()
    },
    checkValidationInfo (id) {
      let isOk = true
      const frm = document.querySelector('#frm_shipping')
      const selector = frm.querySelector('#' + id)
      const regParams = this.regParams

      if (id === 'cneCstEnm') {
        if (regParams.dlyCtrCd === 'MX' && selector.value.includes('BANK')) {
          let imShprTaxId_selector = frm.querySelector('#imShprTaxId')
          let imCneTaxId_selector = frm.querySelector('#imCneTaxId')

          this.$ekmtcCommon.hideErrorTooltip(imShprTaxId_selector)
          this.$ekmtcCommon.hideErrorTooltip(imCneTaxId_selector)
        }
      }

      if (id !== 'podHsCd' && id !== 'hsCd') {
        this.$ekmtcCommon.hideErrorTooltip(selector)
      }

      if (id === 'blPrtrCont') {
        if (this.$ekmtcCommon.isNotEmpty(selector.value)) {
          if (this.regParams.blPrtrCont.length > 57) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.207'))
            isOk = false
          }
        } else if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      } else if (id === 'ntifIdNo') {
        const ntifIdInfo = this.notiCstIdList.filter(vo => vo.cstIdCatCd === regParams.ntifIdCatCd)

        if (regParams.polPortCd === 'PKG' || regParams.polPortCd === 'PKW') {
          if (this.$ekmtcCommon.isNotEmpty(selector.value) && ntifIdInfo !== undefined && ntifIdInfo.length > 0) {
            if (Number(ntifIdInfo[0].minInpLen) > selector.value.length ||
                Number(ntifIdInfo[0].maxInpLen) < selector.value.length
            ) {
              const message = this.$t('msg.CSBL200.212') + ntifIdInfo[0].minInpLen + ' ~ ' + ntifIdInfo[0].maxInpLen + ')'
              this.$ekmtcCommon.showErrorTooltip(selector, message)
              isOk = false
            }
          } else if (this.$ekmtcCommon.isNotEmpty(frm.querySelector('#ntifIdCatCd').value) && this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          }
        } else {
          if (this.$ekmtcCommon.isNotEmpty(selector.value) && ntifIdInfo !== undefined && ntifIdInfo.length > 0) {
            if (Number(ntifIdInfo[0].minInpLen) > selector.value.length ||
                Number(ntifIdInfo[0].maxInpLen) < selector.value.length
            ) {
              const message = this.$t('msg.CSBL200.212') + ntifIdInfo[0].minInpLen + ' ~ ' + ntifIdInfo[0].maxInpLen + ')'
              this.$ekmtcCommon.showErrorTooltip(selector, message)
              isOk = false
            }
          }
        }
      } else if (id === 'iecNo') {
        if (regParams.polCtrCd === 'IN' && this.$ekmtcCommon.isEmpty(selector.value)) {
          if (this.$ekmtcCommon.isEmpty(regParams.panNo)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.213'))
            isOk = false
          }
        } else if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else {
          if (selector.value.length < 10) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.214'))
            isOk = false
          }
        }
      } else if (id === 'ntifPanNo') {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else if (selector.value.length < 10) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.214'))
          isOk = false
        }
      } else if (id === 'etTaxNo') {
        if (this.$ekmtcCommon.isEmpty(regParams.etTaxNo)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else if (regParams.etTaxNo.length !== 16) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.558'))
          isOk = false
        }
      } else if (id === 'bzplcDsthNo') {
        if (this.$ekmtcCommon.isEmpty(regParams.bzplcDsthNo)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else if (regParams.bzplcDsthNo.length !== 22) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.559'))
          isOk = false
        }
      } else if (id === 'grsWt') {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        } else {
          //SR 1428093 콜롬보향 중량 소수점 2자리 처리
          if (this.regParams.podPortCd === 'CMB') {
            if (selector.value.indexOf('.') > -1) {
              if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
                isOk = false
              }
            }
          }
        }
      } else if (id.indexOf('wt') === 0) {
        //SR 1428093 콜롬보향 중량 소수점 2자리 처리
        if (this.regParams.podPortCd === 'CMB') {
          if (selector.value.indexOf('.') > -1) {
            if (selector.value.substring(selector.value.indexOf('.') + 1).length > 2) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.550'))
              isOk = false
            }
          }
        }
      } else if (id === 'acidNo') {
        if (this.regParams.podCtrCd === 'EG') {
          if (this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          } else {
            if (selector.value.length !== 19) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.295'))
              isOk = false
            }
          }
        }
      } else if (id === 'cneAcidNo') {
        if (this.regParams.podCtrCd === 'EG') {
          if (this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          } else {
            if (selector.value.length !== 9) {
              this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200.296'))
              isOk = false
            }
          }
        }
      } else if (id === 'idTaxNo') {
        if (this.regParams.podCtrCd === 'ID' || this.regParams.podCtrCd === 'JO' || this.regParams.podCtrCd === 'TZ' || this.regParams.podCtrCd === 'VN') {
          this.$ekmtcCommon.hideErrorTooltip(selector)
          if (this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          } else {
            if (this.regParams.podCtrCd === 'ID') {
              if (this.regParams.idTaxNo.length !== 16) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200_M.038'))
                isOk = false
              }
            } else if (this.regParams.podCtrCd === 'JO' || this.regParams.podCtrCd === 'TZ') {
              if (this.regParams.idTaxNo.length !== 9) {
                this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBL200_M.043'))
                isOk = false
              }
            }
          }
        }
      } else if (id === 'grsCbm') {
        // 테스트 끝나면 주석 해제
        if (this.regParams.podCtrCd === 'BH' || this.regParams.dlyCtrCd === 'MX') {
          if (Number(this.regParams.grsCbm) <= 0) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.238'))
            isOk = false
          }
        }
      } else if (id === 'amsType') {
        if (selector !== null) {
          if (this.$ekmtcCommon.isEmpty(selector.value)) {
            this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
            isOk = false
          }
        }
      } else {
        if (this.$ekmtcCommon.isEmpty(selector.value)) {
          this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          isOk = false
        }
      }

      return isOk
    }
  }
}
</script>
<style scoped>
  .tooltip_wrap .cont {padding: 20px;}
  .div_seal+.div_seal {margin-top: 5px;}
  .tbl_mark td{vertical-align: top;}
</style>
